/* ============
 * State of utilities module
 * ============
 *
 * The initial state of the utilities module.
 */

export default {
  paymentsParams: null,
  subscribe: 0
}



// WEBPACK FOOTER //
// ./src/store/modules/utilities/state.js